import React from 'react'
import "./Button.css"

const Button = ({text, onClick, classname=""}) => {
  return (
    <button className={`newBtn ${classname}`} onClick={onClick}>{text}</button>
  )
}

export default Button